export const EMBEDDED_VIRAL_LINK_URL = '/embedded-viral-link/';
export const EMBEDDED_VIRAL_LINKS = {
  FORMS: 'forms',
  LIVE_CHAT: 'live-chat'
};
export const VIRAL_LINK_POST_MESSAGES = {
  SET_IFRAME_HEIGHT: 'SET_IFRAME_HEIGHT'
};
export const possibleViralLinkLocales = ['en', 'ru', 'it', 'el', 'pl', 'ro', 'af', 'tr', 'id', 'tl', 'pt', 'bn', 'th', 'fr', 'he', 'ja', 'de', 'ca', 'hu', 'ms', 'zh', 'es', 'sk', 'es', 'nl', 'fr', 'sv', 'da', 'bg', 'vi', 'cs', 'hr', 'fi', 'en', 'ko', 'uk', 'lt', 'zh', 'sl', 'ar', 'no', 'pt'];